<template>
    <van-popup v-model="show" class="sharePopupBox">
        <div class="sharePopup">
            <div class="imgBox">
                <img :src="require('@/common/images/activeTools/share_icon.png')" alt="">
            </div>
            <p class="textTips">点击此页面右上角“…”，选择【发送给朋友】</p>
            <div class="btnBox">
                <van-button type="default" @click="iKnow">我知道了</van-button>
            </div>
        </div>
    </van-popup>
</template>
<script>
export default {
    name: 'sharePopup',
    data() {
        return {
            show: false
        }
    },
    methods: {
        iKnow() {
            this.show = false
        },
        open() {
            this.show = true
        }
    }
}
</script>
<style lang="scss">
.sharePopupBox{
    background: transparent;
    top: 22%;
    width: 100%;
    .sharePopup{
        .imgBox{
            text-align: right;
            padding: 0.44rem 0.72rem 0.3rem;
            img{
                width: 2.27rem;
                height: 3.02rem;
            }
        }
        .textTips{
            text-align: center;
            font-size: 0.32rem;
            color: #fff;
            font-weight: 500;
        }
        .btnBox{
            text-align: center;
            padding-top: 0.68rem;
            .van-button{
                width: 2.6rem;
                height: 0.8rem;
                border-radius: 0.4rem;
                background: transparent;
                border: 0.03rem solid rgba(255,255,255,1);
                color: #fff;
                font-size: 0.32rem;
            }
        }
        
    }
}
    
</style>